import { ChangeDetectionStrategy, Component } from '@angular/core';
import * as FlatModels from "@medsurf/flat-models";

@Component({
    selector: 'medsurf-slide-edit-free-form-interactive-area',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './free-form-interactive-area.component.html',
    styleUrls: ['./free-form-interactive-area.component.scss'],
    standalone: false
})
export class FreeFormInteractiveAreaComponent {
  readonly FlatModels = FlatModels;
}
